import {
    GetRenderedServiceListQuery,
    RenderedServiceEventData,
    GetRenderedServiceEventsQuery,
    RenderedServiceWithEventsResponse,
    LEGACY_RenderedServiceListResponse,
    RenderedServiceListResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

import { EhrApi } from './EhrApi';

const BASE_URL = '/api/rendered-service';
const EHR_RENDERED_SERVICES_BASE_URL = '/api/ehr/rendered-service';

export class RenderedServiceApi {
    /** @deprecated*/
    public static async getListForEhr(
        params?: GetRenderedServiceListQuery,
    ): Promise<LEGACY_RenderedServiceListResponse> {
        const {
            data: { renderedServices, ehrsCount },
        } = await axios.get<LEGACY_RenderedServiceListResponse>(EHR_RENDERED_SERVICES_BASE_URL, { params });
        const withoutEhrs = renderedServices.filter(rs => !rs.ehr);
        const notLoadedEhrIds = new Set<string>();
        const rsWithoutEhr = new Set<string>();
        withoutEhrs.forEach(({ id, ehrId }) => {
            notLoadedEhrIds.add(ehrId);
            rsWithoutEhr.add(id);
        });
        const ehrs =
            notLoadedEhrIds.size > 0
                ? await EhrApi.find({
                      ids: Array.from(notLoadedEhrIds.values()).join(','),
                      limit: notLoadedEhrIds.size,
                  })
                : [];

        return {
            ehrsCount,
            renderedServices: renderedServices.map(({ ehr, ...rs }) => ({
                ...rs,
                ehr: rsWithoutEhr.has(rs.id) ? ehrs.find(({ id }) => id === rs.ehrId) : ehr,
            })),
        } as LEGACY_RenderedServiceListResponse;
    }

    public static async getList(params?: GetRenderedServiceListQuery): Promise<RenderedServiceListResponse> {
        const res = await axios.get<RenderedServiceListResponse>(BASE_URL, { params });
        return res.data;
    }

    public static async getEvents(id: string): Promise<RenderedServiceEventData[]> {
        const res = await axios.get(`${BASE_URL}/${id}/event`);

        return res.data.events;
    }

    public static async getRenderedServicesEvents(
        params?: GetRenderedServiceEventsQuery,
    ): Promise<RenderedServiceWithEventsResponse> {
        const res = await axios.get<RenderedServiceWithEventsResponse>(`${BASE_URL}/event`, { params });

        return res.data;
    }
}
